import * as z$1 from "zod/v4";
//#region src/schemas/http/prepare-readiness.ts
const boundedIdentifierSchema = z$1.string().trim().min(1).max(256);
const reasonCodeSchema = z$1.string().trim().min(1).max(256);
const prepareReadinessRouteParamsSchema = z$1.strictObject({ deviceId: boundedIdentifierSchema });
const getPrepareReadinessQuerySchema = z$1.strictObject({
	agentControllerRefs: z$1.array(z$1.string().trim().min(1).max(256)).optional(),
	lane: boundedIdentifierSchema,
	openMeldServiceRuntimeId: z$1.string().trim().min(1).max(512).optional()
});
const prepareReadinessRuntimeIdSchema = z$1.strictObject({
	source: z$1.literal("runtime_registry_authority"),
	value: z$1.string().trim().min(1).max(512)
});
const prepareReadinessDisplayStateSchema = z$1.enum([
	"ready",
	"pending",
	"unavailable",
	"needs_prepare",
	"needs_repair",
	"stale",
	"unknown"
]);
const prepareReadinessRunnableCapabilitySchema = z$1.strictObject({
	agentControllerRef: z$1.string().trim().min(1).max(256),
	expiresAtMs: z$1.int().nonnegative(),
	observedAtMs: z$1.int().nonnegative(),
	reasonCodes: z$1.array(reasonCodeSchema),
	status: z$1.literal("ready")
});
const prepareReadinessNonRunnableCapabilitySchema = z$1.strictObject({
	agentControllerRef: z$1.string().trim().min(1).max(256),
	expiresAtMs: z$1.int().nonnegative().optional(),
	observedAtMs: z$1.int().nonnegative().optional(),
	reasonCodes: z$1.array(reasonCodeSchema),
	status: z$1.enum([
		"disabled",
		"invalid",
		"missing",
		"stale",
		"unavailable",
		"unknown"
	])
});
const prepareReadinessProjectionSchema = z$1.strictObject({
	allRunnableCapabilitiesPrepared: z$1.strictObject({ status: z$1.enum([
		"prepared",
		"not_prepared",
		"partial",
		"unknown"
	]) }).optional(),
	projectionStatus: prepareReadinessDisplayStateSchema,
	reasonCodes: z$1.array(reasonCodeSchema),
	serviceReadiness: z$1.strictObject({ status: z$1.enum([
		"running",
		"starting",
		"not_running",
		"not_installed",
		"needs_repair",
		"unavailable",
		"unknown"
	]) }).optional()
});
const prepareReadinessSummarySchema = z$1.strictObject({
	displayState: prepareReadinessDisplayStateSchema,
	ready: z$1.boolean(),
	reasonCodes: z$1.array(reasonCodeSchema)
});
const getPrepareReadinessResponseSchema = z$1.strictObject({
	agentControllerReportsRead: z$1.boolean(),
	nonRunnableCapabilities: z$1.array(prepareReadinessNonRunnableCapabilitySchema),
	projection: prepareReadinessProjectionSchema,
	reason: z$1.enum([
		"openmeld_service_runtime_identity_invalid",
		"openmeld_service_runtime_id_invalid",
		"openmeld_service_runtime_id_mismatch",
		"runtime_lookup_conflict",
		"runtime_missing",
		"runtime_not_ready"
	]).optional(),
	runnableCapabilities: z$1.array(prepareReadinessRunnableCapabilitySchema),
	openMeldServiceRuntimeId: prepareReadinessRuntimeIdSchema.optional(),
	status: z$1.enum(["not_ready", "ready"]),
	summary: prepareReadinessSummarySchema
}).superRefine((value, context) => {
	if (value.status === "ready" && !value.openMeldServiceRuntimeId) context.addIssue({
		code: "custom",
		message: "ready prepare readiness response requires authority openMeldServiceRuntimeId evidence",
		path: ["openMeldServiceRuntimeId"]
	});
});
//#endregion
export { getPrepareReadinessQuerySchema, getPrepareReadinessResponseSchema, prepareReadinessDisplayStateSchema, prepareReadinessNonRunnableCapabilitySchema, prepareReadinessProjectionSchema, prepareReadinessRouteParamsSchema, prepareReadinessRunnableCapabilitySchema, prepareReadinessRuntimeIdSchema, prepareReadinessSummarySchema };

//# sourceMappingURL=prepare-readiness.js.map